import { coachApi } from '@shared/api/client';
import type { SlotDataResponse } from './types';
import { adaptSlotData } from './adapters';

export const erpBlocksApi = {
  getSlotData: async (slotKey: string): Promise<SlotDataResponse> => {
    try {
      const raw = await coachApi.get<unknown>(`/webbuilder/slots/${slotKey}`);
      return adaptSlotData(raw, slotKey);
    } catch {
      return { slot_key: slotKey, items: [] };
    }
  },
};

export const webbuilderApi = erpBlocksApi;
export type * from './types';
